import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { StudentDetailsEdit } from './StudentDetailsLayouts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputLabel: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1)
    },
    input: {
      marginBottom: theme.spacing(3),
      width: '100%'
    },
    addMoreButtonContainer: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center'
    },
    addMoreButton: {
      fontSize: '1.2rem',
      textTransform: 'unset',
      padding: `0 ${theme.spacing(4)}px 0 ${theme.spacing(2)}px`
    },
    addIcon: {
      marginRight: theme.spacing(1.5),
      fontSize: '1.4rem'
    },
    danger: {
      color: theme.palette.error.main
    },
    radioGroup: {
      flexDirection: 'row'
    }
  })
);

interface StudentDetailsFormProps {
  isEdit?: boolean;
}

export interface DetailsClassroomForm {
  [propName: string]: object;
}

const StudentDetailsForm = ({ isEdit = true }: StudentDetailsFormProps) => {
  const classes = useStyles();
  return isEdit ? <StudentDetailsEdit classes={classes} /> : <div>placeholder</div>;
};

export default StudentDetailsForm;
